import { SEGMENTS_DISPLAY_MODES } from '@constants/page';
import MenuHeaderComponent from '@deckManagement/components/Page/HeaderComponents/MenuHeaderComponent';
import { GridManager } from '@deckManagement/hooks/usePageGridManager';
import { CodeOrDescription } from '@services/api/deckManagement/graphql/schema/API';
import { CustomHeaderProps } from 'ag-grid-react';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { KpiDimension } from 'types/PageSidePanel.types';

/**
 * Dimension header component with dropdown for display mode selection.
 * Renders outside of Page component to avoid React reconciliation issues.
 */
const DimensionHeaderComponent = ({
  dimension,
  dimensionDisplayModes,
  setDimensionDisplayModes,
  gridManagerRef,
  ...props
}: CustomHeaderProps & {
  dimension: KpiDimension;
  dimensionDisplayModes: Record<KpiDimension, CodeOrDescription>;
  setDimensionDisplayModes: Dispatch<SetStateAction<Record<KpiDimension, CodeOrDescription>>>;
  gridManagerRef: MutableRefObject<GridManager | null>;
}) => (
  <MenuHeaderComponent
    {...props}
    displaySelectedLabel={false}
    selected={dimensionDisplayModes[dimension]}
    menuOptionLabels={Object.keys(SEGMENTS_DISPLAY_MODES)}
    menuOptionValues={Object.values(SEGMENTS_DISPLAY_MODES)}
    onChange={(displayMode: unknown) => {
      setDimensionDisplayModes((prev) => ({
        ...prev,
        [dimension]: displayMode as CodeOrDescription,
      }));
      setTimeout(() => {
        gridManagerRef.current?.executeOnAll((gridApi) => {
          gridApi.autoSizeAllColumns();
        });
      }, 200);
    }}
  />
);

export default DimensionHeaderComponent;
